import type { ReactNode } from 'react';

import { FilterBar } from '../../shared/ui/filter-bar';
import { Segmented } from '../../shared/ui/segmented';
import type { IListFilters, IListView } from './lib';

interface IListFilterBarProps<TRow> {
  views: readonly IListView<TRow>[];
  filters: IListFilters;
  onChange: (next: IListFilters) => void;
  counts?: Record<string, number>;
  label: string;
  /** At the bar's right end, e.g. the list's search field. */
  trailing?: ReactNode;
}

export const ListFilterBar = <TRow,>({
  views,
  filters,
  onChange,
  counts,
  label,
  trailing,
}: IListFilterBarProps<TRow>) => (
  <FilterBar>
    <Segmented
      aria-label={label}
      segments={views.map((view) => ({
        value: view.value,
        label: view.label,
        count: counts?.[view.value],
      }))}
      value={filters.view}
      onChange={(value) => onChange({ ...filters, view: value })}
    />
    {trailing}
  </FilterBar>
);
